import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import { useLatestVehicles } from "@cinch-nx/landing-ui-shared";
import { Carousel as LatestCarsCarousel } from "../carousel/carousel";
import styles from "./latest-cars.module.css";
import sharedStyles from "../../car-reviews-v2.module.css";
import { capitaliseFirstLetter } from "../../utils";
export var LatestCars = function(param) {
    var make = param.make, model = param.model;
    var ref = useLatestVehicles({
        make: make,
        model: model,
        count: 5,
        caller: "makesAndModels"
    }), data = ref.data, error = ref.error;
    if (!data) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.carouselLoading,
            children: "Loading..."
        });
    }
    if (error) {
        console.log(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("section", {
        className: sharedStyles.inner,
        children: [
            /*#__PURE__*/ _jsxs(Heading, {
                className: styles.title,
                children: [
                    "Latest ",
                    capitaliseFirstLetter(make),
                    " ",
                    model && capitaliseFirstLetter(model)
                ]
            }),
            /*#__PURE__*/ _jsx(LatestCarsCarousel, {
                carouselName: "latest-cars",
                vehicles: data.vehicleListings
            })
        ]
    });
};
